import type {
  TextPuzzle as TextPuzzleType,
  PuzzleContent,
  Id,
} from '../../../../../../../shared/types'
import { Button } from '../../../../../../common'
import Input from '../../../../../../common/Input/Input'
import DebugJson from '../../../../../../debug/DebugJson/DebugJson'
import { parentMeta } from '../../../../type'
import useTextPuzzle from './useTextPuzzle'
import { Form } from '../../../../../../common/Form/Form'

interface TextPuzzleProps extends TextPuzzleType {
  parentMeta?: parentMeta
  content: PuzzleContent
  filePath?: string
}

const TextPuzzle = (props: TextPuzzleProps) => {
  const { id, parentMeta } = props

  const { guess, register, handleSubmit, formState, errorMessage, debugP2 } =
    useTextPuzzle({
      puzzleId: id,
      sceneId: parentMeta?.id,
    })

  return (
    <div>
      <Form onSubmit={handleSubmit} errorMessage={errorMessage}>
        <Input
          // label="Guess"
          placeholder="? ? ?"
          {...register('guess', { required: 'Guess!' })}
          error={!!formState.errors.guess}
          inputProps={{
            style: { textAlign: 'center' },
          }}
        />
        <Button type="submit">Guess.</Button>
        {debugP2 && (
          <>
            GUESS DATA:
            <DebugJson json={guess?.data} />
          </>
        )}
      </Form>
      <DebugJson json={props} />
    </div>
  )
}

export default TextPuzzle
